// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
/* for components whose styles are define, those components will pick below two configurable colors */
/* 
 - for components whose styles are not defined, those components will pick below two default colors* 
 - add styles for those components if you want configurable colors.
 - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.
 - this is a workaround as antd core styles do not accept css variables as less variable values.
*/
::selection {
  background-color: var(--app-primary-color);
  color: #fff;
}
.index-module__title-container__zhTq9 {
  display: flex;
  justify-content: flex-start;
  gap: 30px;
  align-items: center;
}
.index-module__extra-container__p2yjt {
  text-align: center;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 30px;
}
.index-module__head-container__DH8yT {
  width: 100% !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__select-master__F_H03 {
  margin-left: 200px;
  margin-top: -17px;
  display: flex;
  justify-content: flex-start;
}
.index-module__input-dropdown__vNq1W {
  width: 100%;
}
.index-module__input-search__qeNIq {
  min-width: 100%;
}
.index-module__div-container__mO2Xh {
  position: absolute;
  top: 10px;
  padding-left: 184px;
  display: flex;
  width: 100%;
}
.index-module__search-container__RBbsq {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10%;
  width: 100%;
}
.index-module__select-master-dropdown__yfRF6 {
  width: 200px;
}
.index-module__icon-delete-close__OXuTP {
  font-size: 23px;
}
.index-module__icon-save__IyEDA {
  font-size: 23px;
  margin-right: 25px;
}
.index-module__action-icon__ru1ux {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  margin-right: 1rem;
}
.index-module__image__CYfXB {
  width: 50px;
  height: 50px;
}
.index-module__disabled__r6Qi9 {
  color: grey;
  cursor: not-allowed !important;
}
.index-module__user-master-container__Kq44G {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.6rem;
}
.index-module__user-master-container__Kq44G .index-module__section1__i4h4t {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 2rem;
}
.index-module__user-master-container__Kq44G .index-module__section2__vK0Ob {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
}
.index-module__customer-location-container__ixjcY {
  display: flex;
}
.index-module__delete-customer-icon__p1x6h {
  color: red;
  font-size: 20px;
  margin-left: 10px;
}
.index-module__form-required-field__nOwbz {
  color: red;
}
@media only screen and (max-width: 700px) {
  .index-module__select-master-dropdown__yfRF6 {
    width: 150px !important;
  }
  .index-module__input-search__qeNIq {
    display: none;
  }
}
@media only screen and (min-width: 700px) and (max-width: 992px) {
  .index-module__select-master-dropdown__yfRF6 {
    width: 120px !important;
  }
  .index-module__input-search__qeNIq {
    min-width: 20%;
  }
}
/* Mobile styles */
@media (max-width: 480px) {
  .index-module__user-master-container__Kq44G {
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManagement/index.module.less"],"names":[],"mappings":"AAAA,4FAA4F;AAC5F,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAC7F,qGAAqG;AACrG;;;;;CAKC;AACD;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;AACF;AACA,kBAAkB;AAClB;EACE;IACE,eAAe;IACf,2BAA2B;IAC3B,uBAAuB;IACvB,WAAW;EACb;AACF","sourcesContent":["/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n/* for components whose styles are define, those components will pick below two configurable colors */\n/* \n - for components whose styles are not defined, those components will pick below two default colors* \n - add styles for those components if you want configurable colors.\n - @primary-color and @secondary-color cannot be changed because it is used by antd, if removed it will default to antd default primary and secondary color.\n - this is a workaround as antd core styles do not accept css variables as less variable values.\n*/\n::selection {\n  background-color: var(--app-primary-color);\n  color: #fff;\n}\n.title-container {\n  display: flex;\n  justify-content: flex-start;\n  gap: 30px;\n  align-items: center;\n}\n.extra-container {\n  text-align: center;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 30px;\n}\n.head-container {\n  width: 100% !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.select-master {\n  margin-left: 200px;\n  margin-top: -17px;\n  display: flex;\n  justify-content: flex-start;\n}\n.input-dropdown {\n  width: 100%;\n}\n.input-search {\n  min-width: 100%;\n}\n.div-container {\n  position: absolute;\n  top: 10px;\n  padding-left: 184px;\n  display: flex;\n  width: 100%;\n}\n.search-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10%;\n  width: 100%;\n}\n.select-master-dropdown {\n  width: 200px;\n}\n.icon-delete-close {\n  font-size: 23px;\n}\n.icon-save {\n  font-size: 23px;\n  margin-right: 25px;\n}\n.action-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 20px;\n  margin-right: 1rem;\n}\n.image {\n  width: 50px;\n  height: 50px;\n}\n.disabled {\n  color: grey;\n  cursor: not-allowed !important;\n}\n.user-master-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.6rem;\n}\n.user-master-container .section1 {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 2rem;\n}\n.user-master-container .section2 {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2rem;\n}\n.customer-location-container {\n  display: flex;\n}\n.delete-customer-icon {\n  color: red;\n  font-size: 20px;\n  margin-left: 10px;\n}\n.form-required-field {\n  color: red;\n}\n@media only screen and (max-width: 700px) {\n  .select-master-dropdown {\n    width: 150px !important;\n  }\n  .input-search {\n    display: none;\n  }\n}\n@media only screen and (min-width: 700px) and (max-width: 992px) {\n  .select-master-dropdown {\n    width: 120px !important;\n  }\n  .input-search {\n    min-width: 20%;\n  }\n}\n/* Mobile styles */\n@media (max-width: 480px) {\n  .user-master-container {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 0.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-container": `index-module__title-container__zhTq9`,
	"extra-container": `index-module__extra-container__p2yjt`,
	"head-container": `index-module__head-container__DH8yT`,
	"select-master": `index-module__select-master__F_H03`,
	"input-dropdown": `index-module__input-dropdown__vNq1W`,
	"input-search": `index-module__input-search__qeNIq`,
	"div-container": `index-module__div-container__mO2Xh`,
	"search-container": `index-module__search-container__RBbsq`,
	"select-master-dropdown": `index-module__select-master-dropdown__yfRF6`,
	"icon-delete-close": `index-module__icon-delete-close__OXuTP`,
	"icon-save": `index-module__icon-save__IyEDA`,
	"action-icon": `index-module__action-icon__ru1ux`,
	"image": `index-module__image__CYfXB`,
	"disabled": `index-module__disabled__r6Qi9`,
	"user-master-container": `index-module__user-master-container__Kq44G`,
	"section1": `index-module__section1__i4h4t`,
	"section2": `index-module__section2__vK0Ob`,
	"customer-location-container": `index-module__customer-location-container__ixjcY`,
	"delete-customer-icon": `index-module__delete-customer-icon__p1x6h`,
	"form-required-field": `index-module__form-required-field__nOwbz`
};
export default ___CSS_LOADER_EXPORT___;
